<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'

interface Props {
  /** Section heading shown at the top of the placeholder. */
  title: string
  /** Optional crumb / breadcrumb shown above the title. */
  section?: string
  /** Optional secondary line under the title. */
  subtitle?: string
}

withDefaults(defineProps<Props>(), {
  section: '',
  subtitle: '',
})
</script>

<template>
  <Box class="placeholder-page" flex direction="col" align="center" justify="center" gap="3">
    <Box class="placeholder-icon" flex align="center" justify="center">
      <PiIcon name="hourglass" />
    </Box>
    <Box flex direction="col" align="center" gap="1">
      <Text
        v-if="section"
        type="caption-sm"
        transform="uppercase"
        weight="semibold"
        color="muted"
        >{{ section }}</Text
      >
      <Text type="page-title" align="center">{{ title }}</Text>
      <Text v-if="subtitle" type="body" color="muted" align="center">{{ subtitle }}</Text>
    </Box>
    <Text type="caption" color="muted">Module shell — content lands in Phase 2.</Text>
  </Box>
</template>

<style scoped>
.placeholder-page {
  min-height: 60vh;
  padding: 3rem 1.5rem;
}

.placeholder-icon {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background: var(--p-primary-50);
  color: var(--p-primary-500);
  font-size: 1.5rem;
}
</style>
